import  { useEffect, useRef, useState } from 'react';
import { TitleText } from './titleText';



export const  Title=() =>{
  
  const [carouselScrollVal,setCarouselScrollVal]=useState(0)
  const [status,setStatus]=useState('')
  const titleRef=useRef<HTMLDivElement>(null)
  const sliderRef=useRef<HTMLDivElement>(null)
  const [imageScale,setImageScale]=useState({
    width:window.screen.width,
    height:window.screen.height*(60/100)
  })

  useEffect(()=>{
    console.log(titleRef.current?.offsetHeight)
    sliderRef.current!.style.margin=`${-48-titleRef.current!.offsetHeight}px 0px -39px 0px`
    console.log(sliderRef.current!.style.margin)
    setImageScale({
      width:window.screen.width,
      height:window.screen.height*(60/100)
    })
  },[window.screen.height||window.screen.width])

  const [sldierCards,setSliderCards]=useState([
    {
      id:1,
      path:'../../../static/bg-image.jpg'
    },
    {
      id:2,
      path:'../../../static/bg-image.jpg'
    },
    {
      id:3,
      path:'../../../static/bg-image.jpg'
    },
    {
      id:4,
      path:'../../../static/bg-image.jpg'
    },
    {
      id:5,
      path:'../../../static/bg-image.jpg'
    },
    {
      id:6,
      path:'../../../static/bg-image.jpg'
    },
    {
      id:7,
      path:'../../../static/bg-image.jpg'
    }
  ])

  const sliderhandler=(actionType:string)=>{
    switch(actionType){
      case 'scrollBack':
        if(0==carouselScrollVal){
          setStatus('scrollBack-negative')
          setCarouselScrollVal(-(sldierCards.length*imageScale.width-imageScale.width))
        }
        else{
          setStatus('scrollBack-positive')
          setCarouselScrollVal(carouselScrollVal+imageScale.width)
        }
        break;
      case 'scrollForward':
        if(sldierCards.length*imageScale.width-imageScale.width==-carouselScrollVal){
          setCarouselScrollVal(0)
          setStatus('scrollForward-negative')
        }else{
          setStatus('scrollForward-positive')
          setCarouselScrollVal(carouselScrollVal-imageScale.width)
        }
        break;
    }
  }

  return (
      <div ref={sliderRef} style={{margin:`rem(-48-${titleRef.current?.offsetHeight}) 0px rem(-39) 0px`}} className='slider_placeholder'>
        <div ref={titleRef} style={{display:'block'}}>
          <TitleText/>
        </div>
        <div style={{top:`${imageScale.height*(85/100)}px`}} className='carousel_arrows '>
          <svg onClick={()=>sliderhandler('scrollBack')} width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle opacity="0.5" cx="24" cy="24" r="24" fill="white"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M21.2071 29.2071C20.8166 29.5976 20.1834 29.5976 19.7929 29.2071L15.2929 24.7071C14.9024 24.3166 14.9024 23.6834 15.2929 23.2929L19.7929 18.7929C20.1834 18.4024 20.8166 18.4024 21.2071 18.7929C21.5976 19.1834 21.5976 19.8166 21.2071 20.2071L18.4142 23H32C32.5523 23 33 23.4477 33 24C33 24.5523 32.5523 25 32 25H18.4142L21.2071 27.7929C21.5976 28.1834 21.5976 28.8166 21.2071 29.2071Z" fill="#424551"/>
          </svg>
          <svg onClick={()=>sliderhandler('scrollForward')} width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle opacity="0.5" cx="24" cy="24" r="24" fill="white"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M26.7929 18.7929C27.1834 18.4024 27.8166 18.4024 28.2071 18.7929L32.7071 23.2929C33.0976 23.6834 33.0976 24.3166 32.7071 24.7071L28.2071 29.2071C27.8166 29.5976 27.1834 29.5976 26.7929 29.2071C26.4024 28.8166 26.4024 28.1834 26.7929 27.7929L29.5858 25H16C15.4477 25 15 24.5523 15 24C15 23.4477 15.4477 23 16 23H29.5858L26.7929 20.2071C26.4024 19.8166 26.4024 19.1834 26.7929 18.7929Z" fill="#424551"/>
          </svg>

        </div>
        <div className='slider_images  '>
          
          <div style={{left:carouselScrollVal,width:`${sldierCards.length*100}vw`}} className='images-placeholder'>
            {sldierCards.map((p,i)=>
              <div key={i} className='slider_image -ibg'>
                <img src={require(`../../../static/bg-image.jpg`)}/>
              </div>
            )}
          </div>
        </div>
        
        <div className='carousel_indicators __container'>
            {sldierCards.map((p,i)=>
              <div onClick={()=>setCarouselScrollVal(-p.id*imageScale.width+imageScale.width)} key={p.id} className={`carousel_indicator ${carouselScrollVal/-imageScale.width+1==p.id?`active`:``}`}> 
                <p className={`${carouselScrollVal/-imageScale.width+1==p.id?`active`:``}`}>0{p.id}</p><br/>
                <div className={`${carouselScrollVal/-imageScale.width+1==p.id?`active`:``}`}> </div>
              </div>
            )}
        </div>
        
      </div>
  );
}

